import type { IErrorResponse, SignUpRequest, SignUpResponse } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useTranslation } from '@/hooks';
import { urls } from '@/statics';
import { api, standaloneToast } from '@/utils';
import { googleEventSignup } from '@/utils/googleAnalyticsEvent';

const useSignUp = (): UseMutationResult<
  SignUpResponse,
  IErrorResponse,
  Partial<SignUpRequest>
> => {
  const { t } = useTranslation('messages');

  return useMutation({
    mutationFn: (data) => api.post(urls.signUp, data),
    onSuccess: () => {
      standaloneToast({
        status: 'success',
        title: t('yourLoginIsSuccess'),
      });
      googleEventSignup();
    },
  });
};

export default useSignUp;
